import styled from 'styled-components';

export const SvgStyled = styled.svg`
  &[data-has-cursor-pointer='true'] {
    cursor: pointer;
  }
`;
